import { render, staticRenderFns } from "./SingleReservedAccount.vue?vue&type=template&id=6ef51208&scoped=true&"
import script from "./SingleReservedAccount.vue?vue&type=script&lang=js&"
export * from "./SingleReservedAccount.vue?vue&type=script&lang=js&"
import style0 from "./SingleReservedAccount.vue?vue&type=style&index=0&id=6ef51208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef51208",
  null
  
)

export default component.exports